import Head from 'next/head';

import {
  getServerSideProductProps,
  ProductDetailServerSideProps,
} from '../../src/shared/utils/server-side-props';
import useProductDetailPage
  from '../../src/product/detail/hooks/useProductDetailPage';

import Meta from '../../src/shared/components/Head/Meta';

import MainSiteProvider
  from '../../src/main/components/shared/MainSiteProvider';
import ProductDetailContainer
  from '../../src/product/detail/pc/containers/ProductDetailContainer';
import { useScreenName } from '../../src/shared/hooks';
import { ScreenName } from '../../src/shared/amplitude';
import Header from '../../src/header/components/Header';

export default function ProductPage({ product, adultVerificationFailed, verificationEmployeeFailed, error }: ProductDetailServerSideProps) {
  useScreenName(ScreenName.PRODUCT_DETAIL_DESCRIPTION);
  useProductDetailPage({
    product,
    adultVerificationFailed,
    verificationEmployeeFailed,
    error,
  });

  if (!product || adultVerificationFailed) {
    return null;
  }

  const { no, name, shortDescription, shareImageUrl } = product;

  const title = `${name} :: 내일의 장보기, 마켓컬리`;

  return (
    <>
      <Head>
        <title>{title}</title>
        <Meta
          title={title}
          description={`${shortDescription} :: Love Food, Love Life. 마켓컬리! 당일 수확 채소, 과일, 맛집 음식까지 내일 아침 문 앞에서 만나요!`}
          image={shareImageUrl}
          url={`https://www.kurly.com/goods/${no}`}
          keyword='마켓컬리, 신선식품'
        />
      </Head>
      <MainSiteProvider>
        <div id='top'>
          <Header />
          <ProductDetailContainer product={product} />
        </div>
      </MainSiteProvider>
    </>
  );
}

export const getServerSideProps = getServerSideProductProps();
